import ClashDisplayMedium from '../../assets/fonts/ClashDisplay-Medium.woff2'
import ClashDisplaySemibold from '../../assets/fonts/ClashDisplay-Semibold.woff2'
import InterBold from '../../assets/fonts/Inter-Bold.woff2'
import InterRegular from '../../assets/fonts/Inter-Regular.woff2'
import InterLight from '../../assets/fonts/Inter-Light.woff2'
import InterMedium from '../../assets/fonts/Inter-Medium.woff2'

const BAR_HEIGHT = 73.59

const MuiCssBaseline = () => ({
  styleOverrides: () => `
    @font-face {
      font-family: 'ClashDisplay-Medium';
      src: local('Clash Display Medium'), local('Clash-Display-Medium'),
        url(${ClashDisplayMedium}) format('woff2');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'ClashDisplay-Semibold';
      src: local('Clash Display Semibold'), local('Clash-Display-Semibold'),
        url(${ClashDisplaySemibold}) format('woff2');
      font-weight: 600;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Inter';
      src: local('Inter Bold'), local('Inter-Bold'),
          url(${InterBold}) format('woff2');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Inter';
      src: local('Inter Regular'), local('Inter-Regular'),
        url(${InterRegular}) format('woff2');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Inter';
      src: local('Inter Light'), local('Inter-Light'),
        url(${InterLight}) format('woff2');
      font-weight: 300;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Inter';
      src: local('Inter Medium'), local('Inter-Medium'),
        url(${InterMedium}) format('woff2');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }

    #payper-reading-bar-root {
      
      position: fixed;
      z-index: 9000000000000;

      display: flex;
      flex-direction: column;
      min-height: 100vh;
      --payper-bar-height: calc(${BAR_HEIGHT}px + env(safe-area-inset-bottom, 28px));
      --container-max-width: calc(100% - 2.5em);
      --content-L-max-width: 69.75em;
      --content-M-max-width: 37.5em;
      --content-S-max-width: 50%;
      --button-max-width: 100%;
      --main-layout-width: calc(100% - 2em);

      @media (min-width: 601px) {
        --container-max-width: min(calc(100% - 2.5em), 800px);
        --content-S-max-width: 20em;
        --button-max-width: var(--content-S-max-width);
        --main-layout-width: min(var(--content-L-max-width), calc(100% - 5em));
      }
    }

    #payper-reading-bar-root, #payper-reading-bar-root * {
      [type='button']:hover {
        opacity: initial;
        color: inherit;
      }

      input[type='text'],
      input[type='email'],
      input[type='search'],
      input[type='password'],
      input[type='submit'],
      select,
      textarea,
      button {
        color: inherit;
        outline: none;
        border: initial;
        border-width: initial;
        border-style: initial;
        border-radius: initial;
        margin: 0;
        padding: initial;
        font-family: inherit;
        width: inherit;
        border-color: initial;
        font-size: inherit;
        font-weight: inherit;
      }
    }

    a:-webkit-any-link:focus-visible {
      outline-offset:0
    }
  `,
})

export default MuiCssBaseline
